import React, { CSSProperties } from 'react';

import MCardView from './MCard.view';

type Props = {
  className?: string;
  style?: CSSProperties;
};

const MCard: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MCardView className={props.className} style={props.style}>
      {props.children}
    </MCardView>
  );
};

MCard.displayName = 'MCard';
MCard.defaultProps = {};

export default MCard;
